import { useTranslation } from 'react-i18next';

const FormFile = ({ label, register, name, filePath, fileName, onChange, errors, type = "file", language, colSize = 4, required = true, step = "any", mainStore, disabled = false }) => {
    const { t } = useTranslation();
    const colClass = `col-lg-${colSize} mb-3`;
    return (
        <div className={colClass}>
            <div className="form-group">
                <label className="labelDescription">
                    <span className="labelText">
                        {t(label)} {language && <span>{t(language)}</span>}
                    </span>
                    {required && <span className="labelStar text-danger fw-bold">*</span>}
                </label>
                <input
                    type={type}
                    disabled={disabled}
                    onChange={onChange}
                    className={`form-control  rounded-0 ${errors[name] ? "requiredInput" : ""
                        }`}
                    accept="*"
                    name={name}
                />
                {filePath && (
                    <div className='link-primary' style={{ cursor: "pointer" }}>
                        <i className="bi bi-file-earmark-fill text-info mx-1"></i>
                        <span>{fileName}</span>
                    </div>
                )}
                {errors[name] && (
                    <div className="error-message text-danger">
                        {errors[name].message}
                    </div>
                )}
            </div>
        </div>
    );
};

export default FormFile;